import { AnimationOnScroll } from 'react-animation-on-scroll';
import * as ReactUI from 'react-bootstrap';
import { useRecoilValue } from 'recoil';
import { backgroundThemeState } from '../../atoms';
import { skills } from '../../data';
import './styles.scss';

const match = 'nature.36594d9cff251940614c.jpeg';

export default function Skills() {
  const background = useRecoilValue(backgroundThemeState);
  console.log({ background });

  const activateBlur = () => {
    if (background.includes(match)) return 'paragraph-nature';

    return 'paragraph';
  };

  return (
    <ReactUI.Row id="main-row">
      <ReactUI.Col md={12} lg={12}>
        <div className="mt-2">
          <h6 className="heading">Skills</h6>
          <AnimationOnScroll className="animate__fadeInRightBig">
            <b style={{ fontFamily: 'Bitter, serif' }}>
              My current stack and the technologies I use:
            </b>
            <div
              style={{ flexWrap: 'wrap', justifyContent: 'center' }}
              className={`${activateBlur()} d-flex align-items-baseline mt-3`}
            >
              {skills.map((skill) => (
                <div
                  key={skill.name}
                  style={{ marginRight: '30px', padding: '8px 8px' }}
                  className="d-flex flex-column align-items-center mb-3"
                >
                  <ReactUI.Image
                    className="text-center"
                    src={skill.icon}
                    alt=""
                    width="60px"
                    height="60px"
                  />
                  <div className="text-center">{skill.name}</div>
                </div>
              ))}
            </div>
          </AnimationOnScroll>
        </div>
      </ReactUI.Col>
    </ReactUI.Row>
  );
}
